import useImmutableSWR from 'swr/immutable';
import type {SWRResponse} from 'swr';
import {CACHE_KEY} from './key';
import type {MusicQuizPageQuery} from '@app/modules/graphql/generated';

export function useMusicQuizPageData(): SWRResponse<MusicQuizPageQuery> {
	// This hook is only used to return the cached value, returns null otherwise
	return useImmutableSWR(CACHE_KEY, null);
}
